import { Wifi, Plug, Armchair, Car } from "lucide-react";
import { GRADE_STYLES } from "@/components/cafe-detail/FeatureGradeCard";
import type { LetterGrade } from "@/lib/amenityGrades";

interface Props {
  type: "wifi" | "outlets" | "seating" | "parking";
  grade: LetterGrade;
  label: string;
}

const ICONS = {
  wifi: Wifi,
  outlets: Plug,
  seating: Armchair,
  parking: Car,
};

const TITLES = {
  wifi: "Wi-Fi",
  outlets: "Outlets",
  seating: "Seating",
  parking: "Parking",
};

export function SubScorePill({ type, grade, label }: Props) {
  const Icon = ICONS[type];
  const style = GRADE_STYLES[grade];

  return (
    <div className="flex items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1.5 text-xs text-secondary-foreground sm:text-sm">
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span className="font-medium">{TITLES[type]}</span>
      <span
        className="flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold"
        style={{ backgroundColor: style.ringFill, color: style.ink, border: `1px solid ${style.ringColor}` }}
      >
        {grade === "U" ? "–" : grade}
      </span>

      <span className="text-muted-foreground">{label}</span>
    </div>
  );
}
